export const DEFAULT_ANIMATION_TIME = 300;
